import {AnchorHTMLAttributes, DetailedHTMLProps, FC} from 'react';
import {useMantineTheme} from '@mantine/core';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faExternalLink} from '@fortawesome/pro-regular-svg-icons';

export const AnchorIcon: FC<
  DetailedHTMLProps<AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>
> = ({children, ...props}) => {
  const classes = useStyles();
  return (
    <a style={classes.link} {...props}>
      <FontAwesomeIcon icon={faExternalLink} /> &nbsp; {children}
    </a>
  );
};

const useStyles = () => {
  const theme = useMantineTheme();
  return {
    link: {
      textDecoration: 'none',
      color: theme.colors.primary[6],
    },
  };
};
